import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import "./Cards.css";
import { Button } from 'bootstrap';
// props will be coming from Cards.js
function CardItem(props) {
  return (
    <>
      <li className='cards__item'>
        <Link to={props.path} className='cards__item__link'>
          <figure data-category={props.label} className='cards__item__pic-wrap '>
            <img src={props.src} alt="Travel destination" className='cards__item__img '></img>
          </figure>
          <div className='cards__item__info'>
            <h5 className='cards__item__text'>{props.text}</h5>
            <button className='clr1 pt-2 pb-2 ps-2 pe-2 rounded-3 '><span className='text-dark fs-6'>Price:250 </span></button>
          </div>
        </Link>
      </li>
    </>
  )
}

export default CardItem;
